const cdnBaseUrl = 'https://cash-f.squarecdn.com/web/cash-design-system/assets'

export const getImageUrl = (image: string, ext = 'png') => `${cdnBaseUrl}/images/${image}.${ext}`
